import {Field} from "@components/fields/field"

export {}

const fieldSelector = ".f-text, .f-single-select, .f-checkbox, .f-file, .f-textarea, .f-switch"

const handleFormSubmit = (form: HTMLFormElement) => {
  form.addEventListener("submit", (event: Event) => {
    const fields = [...form.querySelectorAll<HTMLElement>(fieldSelector)].map((field) => new Field(field))

    const isValid = form.checkValidity()
    fields.forEach((field) => field.validate())
    if (!isValid) {
      scrollToInvalid(form)
      event.preventDefault()
      return
    }

    // Prevent double submit
    form.querySelectorAll(`button[type="submit"`).forEach((button) => {
      button.setAttribute("disabled", "")
    })
  })
}

function scrollToInvalid(form: HTMLFormElement) {
  const invalidInputs = Array.from(form.querySelectorAll(":invalid")) // set up so you can use any custom invalid classes you're adding to your elements, as well
  invalidInputs.sort((a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top) // sort inputs by offset from top of viewport (handles issues with multi-column layouts, where the first element in the markup isn't necessarily the highest on the page)

  if (invalidInputs[0]) {
    invalidInputs[0].scrollIntoView({block: "center"}) // scroll first (top) input into center of view,
  }
}

const initForms = () => {
  const formsSelector = "form.--validate:not(.--initialized)"
  const forms = document.querySelectorAll<HTMLFormElement>(formsSelector)

  forms.forEach((form) => {
    /**
     * Setting noValidate turns off the native client-side validation,
     * freeing us up to do whatever we want. Turning off validation with JavaScript ensures
     * the default validation still runs if JavaScript never executes for whatever reason.
     * It also prevents showing our invalid style preemptively.
     */
    form.noValidate = true

    const getFields = () =>
      [...form.querySelectorAll<HTMLElement>(fieldSelector)]
        .filter((field) => !field.classList.contains("--validating"))
        .map((field) => new Field(field))

    getFields().forEach((field) => field.handleInputEvents())

    handleFormSubmit(form)

    form.classList.add("--initialized")

    form.addEventListener("inputsReinit", () => {
      getFields().forEach((field) => field.handleInputEvents())
    })
  })
}

initForms()
document.addEventListener("baseformReinit", initForms)
